import { Card, DatePicker, Skeleton, Typography } from "antd";
import React, { useState } from "react";
import { useEffect } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import { disableFutureDates, formatDate, months } from "../../services/util";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

const grids = [
    { title: "Month", key: "month" },
    { title: "CheckIns", key: "checkins" },
    { title: "CheckOuts", key: "checkouts" },
    { title: "Revenue Growth", key: "revenue_growth" },
    { title: "Hotel Contracted", key: "hotel_contracted" },
    { title: "Hotel Implemented", key: "hotel_implemented" },
    { title: "Cash Volume Facilated", key: "cash_volume_facilitated" },
    { title: "CC Volume Facilated", key: "cc_volume_facilitated" },
    { title: "Hours Covered", key: "hours_covered" },
    { title: "Hours Busy", key: "hours_busy" },
    { title: "Guests Served", key: "guest_served" },
    { title: "No Of reviews", key: "number_of_reviews" },
    { title: "Reviews Rating", key: "review_ratings" },
    { title: "8 Hours Hotels", key: "8_hour_hotels" },
    { title: "16 Hours Hotel", key: "16_hour_hotels" },
    { title: "24 Hours Hotel", key: "24_hour_hotels" },
    { title: "Calls Answered", key: "calls_answered" },
    { title: "Front Desk Agents", key: "front_desk_agents" },
    { title: "Infrastructure Issues", key: "infrastructure_issues" },
    { title: "Operational Issues", key: "operation_issues" },
    { title: "Technology Issues", key: "technology_issues" },
];

function BusinessAnalytics() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [tableData, setTableData] = useState([]);

    const [selectedYear, setSelectedYear] = useState(dayjs());
    const [formData, setFormData] = useState({
        staff_id,
        year: formatDate(selectedYear, "YYYY"),
    });
    const {
        status: analyticsStatus,
        data: analyticsRes,
        refetch: getAnalyticsData,
        isFetching,
    } = useQuery(
        "business-analytics",
        async () =>
            await HTTP("/analytics/getBusinessAnalyticsData", {
                ...formData,
            }),
        {
            select: (res) => {
                const keys = Object.keys(res.data[0]).sort();
                return keys.reduce((prev_k, cur_k) => {
                    const temp = [];
                    let objKey = grids.find((g) => g.key == cur_k).title;
                    if (objKey !== "Month") {
                        temp.push(objKey);
                        temp.push(
                            ...res.data.map((d) => {
                                if (objKey == "Hours Busy")
                                    return d[cur_k] || "-";
                                return d[cur_k];
                            }),
                        );
                        prev_k.push(temp);
                    }
                    return prev_k;
                }, []);
            },
        },
    );

    const columns = [
        {
            title: "",
            render: (record) => {
                return <Typography.Text strong>{record[0]}</Typography.Text>;
            },
            width: "10%",
        },
        ...months.map((m) => {
            return {
                title: () => (
                    <Typography.Text strong>{m.title}</Typography.Text>
                ),
                render: (record) => {
                    return <p>{record[Number(m.key)]}</p>;
                },
                width: "5%",
            };
        }),
    ];

    useEffect(() => {
        getAnalyticsData();
    }, []);

    useEffect(() => {
        getAnalyticsData();
    }, [formData]);

    useEffect(() => {
        setFormData({ ...formData, year: formatDate(selectedYear, "YYYY") });
    }, [selectedYear]);

    useEffect(() => {
        if (analyticsStatus === "success") {
            setTableData(analyticsRes);
        }
    }, [analyticsStatus, analyticsRes]);

    function handleYearSelection(date) {
        if (date != null) setSelectedYear(date);
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader
                extraAfter={
                    <DatePicker
                        allowClear={false}
                        format={"yyyy"}
                        className="margin-right-10"
                        picker="year"
                        onChange={handleYearSelection}
                        defaultValue={dayjs(selectedYear)}
                        value={dayjs(selectedYear)}
                        disabledDate={disableFutureDates}
                    />
                }
            />
            {analyticsStatus !== "loading" &&
            analyticsStatus !== "idle" &&
            !isFetching ? (
                <CustomTable
                    columns={columns}
                    tableData={tableData}
                    pagination={{ hideOnSinglePage: true, pageSize: 21 }}
                    isScroll
                />
            ) : (
                <Skeleton active title={false} paragraph={{ rows: 40 }} />
            )}
        </Card>
    );
}
export { BusinessAnalytics };
